import { render } from "./ColorsSettings.vue?vue&type=template&id=e0c90138"
import script from "./ColorsSettings.vue?vue&type=script&lang=js"
export * from "./ColorsSettings.vue?vue&type=script&lang=js"

import "./ColorsSettings.vue?vue&type=style&index=0&id=e0c90138&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__